import logo from '../../images/logo.svg';
import GoogleSignInButton from "../common/GoogleSignInButton";
import {Navigate} from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import {Alert, Box, Typography} from "@mui/material";
import {FunctionComponent} from "react";
import {UserRole} from "../../constants/UserRole";

const Login: FunctionComponent = () => {
    const {user, role, hasLoaded} = useAuth();

    const isUnauthorized = hasLoaded && !!user && role !== UserRole.ADMIN;

    return (
        <Box sx={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            background: '#FFFFFF',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <header className="App-header">
                <Box sx={{mb: 4}}>
                    <img src={logo} className="App-logo" alt="logo" width={"256px"} height={"256px"}/>
                </Box>
            </header>

            <GoogleSignInButton/>

            {isUnauthorized && (
                <Alert severity={'error'} sx={{mt: 3, maxWidth: 420}}>
                    <Typography variant={'body2'} sx={{mb: 0.5}}>
                        This account does not have admin access.
                    </Typography>
                    <Typography variant={'body2'}>
                        User ID: <strong>{user!.uid}</strong>
                    </Typography>
                </Alert>
            )}

            {role === UserRole.ADMIN && hasLoaded && <Navigate to={'/'} replace={true}/>}
        </Box>
    );
}

export default Login;